
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 13h4v-3l5 4.5-5 4.5v-3h-4v-3zm7-13H2a2 2 0 00-2 2v12a2 2 0 002 2h7v-2H2V4l8 5 8-5v6h2V2a2 2 0 00-2-2zm-8 7L2 2h16l-8 5z","fill":"#000"}})])
          )
        }
      }
    